module.exports = __webpack_public_path__ + "static/media/event.449fde8e.jpg";